__turbopack_context__.v({
  "arrow": "waterAccountItem-module-scss-module__qxmZjq__arrow",
  "buttons-container": "waterAccountItem-module-scss-module__qxmZjq__buttons-container",
  "container": "waterAccountItem-module-scss-module__qxmZjq__container",
  "container-selected": "waterAccountItem-module-scss-module__qxmZjq__container-selected",
  "fade-in-ux308c5": "waterAccountItem-module-scss-module__qxmZjq__fade-in-ux308c5",
  "icon": "waterAccountItem-module-scss-module__qxmZjq__icon",
  "id": "waterAccountItem-module-scss-module__qxmZjq__id",
  "item": "waterAccountItem-module-scss-module__qxmZjq__item",
  "report": "waterAccountItem-module-scss-module__qxmZjq__report",
  "skeleton-reading": "waterAccountItem-module-scss-module__qxmZjq__skeleton-reading",
  "toggle": "waterAccountItem-module-scss-module__qxmZjq__toggle",
  "toggle-border": "waterAccountItem-module-scss-module__qxmZjq__toggle-border",
  "toggle-button": "waterAccountItem-module-scss-module__qxmZjq__toggle-button",
  "toggle-button-selected": "waterAccountItem-module-scss-module__qxmZjq__toggle-button-selected",
  "water-account-list": "waterAccountItem-module-scss-module__qxmZjq__water-account-list",
  "water-account-list-header": "waterAccountItem-module-scss-module__qxmZjq__water-account-list-header",
  "wrapper": "waterAccountItem-module-scss-module__qxmZjq__wrapper",
});
